import { blue } from '@material-ui/core/colors';

export default {
  primary: blue[700],
  secondary: '#d3272c',
};
